import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=2f86c48c"
import script from "./InformationBlock.vue?vue&type=script&lang=js"
export * from "./InformationBlock.vue?vue&type=script&lang=js"
import style0 from "./InformationBlock.vue?vue&type=style&index=0&id=2f86c48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports